import { Component, Input, ViewChild } from '@angular/core';
import Keyboard from 'simple-keyboard';
import { NavParams, Events } from 'ionic-angular';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { ViewController } from 'ionic-angular/navigation/view-controller';

/**
 * Generated class for the CoNgxKeyboardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-ngx-keyboard',
  templateUrl: 'co-ngx-keyboard.html',
})
export class CoNgxKeyboardComponent {
  @Input('target') target: any;
  private standalone: boolean = false;
  private standaloneValue: string = "";
  private keyboard: any;
  private shifted: boolean;
  private keypad: any;
  private keypresses: any = "";
  constructor(private navParams: NavParams, private sounds: SoundsProvider, private viewCtrl: ViewController, private events: Events) {
    // this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.events.subscribe('setOSKTarget', target=>this.setTarget(target));
    this.shifted = false;
  }

  ngOnInit(): void {
	  switch(this.navParams.data.mode){
		case 'standalone':
				this.standalone=true;
			break;
		default:
			this.setTarget(this.navParams.data.target);
			break;
	  }
    this.shifted = false;
    this.keyboard = new Keyboard('.full-keyboard', {
      // onChange: input => this.keyboardPressed(input),
      onKeyPress: button => this.onKeyPress(button),
      layout: {
        default: [
          "q w e r t y u i o p",
          "a s d f g h j k l",
          "{shift} z x c v b n m -",
          "{chars} {space} . @"
        ],
        shift: [
          "Q W E R T Y U I O P",
          "A S D F G H J K L",
          '{shift} Z X C V B N M -',
          "{chars} {space} . @"
        ],
        punctuation: [
          "! # $ % & ' * + \\ /",
          "= ? ^ _ ` { } | ~ \"",
          "( ) < > [ ] , ; : -",
          "{ABC} {space} . @"
        ]
      },
      display: {
        '{enter}': 'enter',
        '{chars}': '! + #',
        '{ABC}': 'ABC',
        '{space}': 'space',
        '{shift}': 'shift'
      }
    });
    this.keypad = new Keyboard('.number-keyboard', {
      // onChange: input => this.keyboardPressed(input),
      onKeyPress: button => this.onKeyPress(button),
      layout: {
        default: [
          "7 8 9",
          "4 5 6",
          "1 2 3",
          "0 {bksp}"
        ]
      },
      display: {
        '{bksp}' : '<img src="assets/imgs/backspace.svg" />'
      }
	});
	this.keypresses = this.standalone ? this.standaloneValue : this.target.value;
  }
  setTarget(target){
	  if(this.target){
		this.target.classList.remove('focusedInputBox');
	  }
	this.target = target;
	this.target.classList.add('focusedInputBox')

	this.keypresses = this.target.value;
  }
  onKeyPress(button) {
    this.sounds.playKeyboardSound();
    if (this.shifted) {
      setTimeout(() => {
        this.keyboard.setOptions({
          layoutName: "default"
        });
      }, 10);
      this.shifted = false;
    }
    if (button === "{shift}") {
      this.handleShiftButton();
    } else if (button === "{bksp}") {
      this.handleBackSpace();
    } else if (button === "{space}"){
      this.keypresses += ' ';
      this.keyboardPressed(this.keypresses);
    } else if (button === "{lock}") {
      this.handleCapsButton();
    } else if (button === "{chars}") {
      this.handlePunctuationButton();
    } else if (button === "{ABC}") {
      this.handlePunctuationButton();
    } else {
      this.keypresses += button;
      this.keyboardPressed(this.keypresses);
    }
  }
  handleShiftButton() {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "shift" ? "default" : "shift";

    setTimeout(() => {
      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    }, 10);

    this.shifted = true;
  }
  handleCapsButton() {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "caps" ? "default" : "caps";
    setTimeout(() => {
      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    }, 10);
  }
  handleBackSpace(){
    this.keypresses = this.keypresses.slice(0, -1);
    this.keyboardPressed(this.keypresses);
  }
  handlePunctuationButton() {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "punctuation" ? "default" : "punctuation";
    setTimeout(() => {
      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    }, 10);
  }
  keyboardPressed(input) {
	if(this.standalone){
		this.standaloneValue = input;
	}else{
		this.target.value = input;
		this.target.dispatchEvent(new Event('input'));
	}
  }
  inputCanceled():void{
	this.viewCtrl.dismiss(null, '', {animate: false}).catch(err=>{});
  }
  inputDone():void{//{},'', {animate: false}
	this.viewCtrl.dismiss(this.standaloneValue, '', {animate: false}).catch(err=>{});
  }
  ngOnDestroy(): void {
	if(this.standalone){

	}else{
		this.target.classList.remove('focusedInputBox'); //removes highlight class on dismiss of keyboard
	}
  }
}


// WEBPACK FOOTER //
// ./src/components/co-ngx-keyboard/co-ngx-keyboard.ts